<template>
   
    <el-dialog
        title="创建号码清洗任务 ？"
        :visible.sync="createCleaningTaskDialog"
        width="516px"
        :before-close="handleClose"
        custom-class="dialog-cleaning-task" >
        <p class="tip" v-if="!taskType"><i class="el-icon-warning"></i><span style="color: #262626;">温馨提示：</span>7天内已清洗的手机号不再重复清洗</p>
        <el-form ref="cleaingTaskform" :rules="rules" :model="cleaingTaskform" label-width="64px">
           <el-form-item label="任务名称" class="task-name"  prop="name">
              <el-input v-model.trim="cleaingTaskform.name" maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="选择范围" class="choice-range" v-if="!taskType">
               <el-radio-group v-model="cleaingTaskform.type" @change="choiceRange">
                  <el-radio :label="1">仅看关键人手机号</el-radio>
                  <!-- <el-radio :label="2">仅看首位手机号</el-radio> -->
                  <el-radio :label="3">全部手机号</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="" class="choice-before" v-if="!taskType">
              清洗解锁列表前<el-input type="text" v-model="cleaingTaskform.before" @input="inputCompanyNum"></el-input>条待检测的<span class="colorC" style="margin-left:14px">{{cleaingTaskform.type == 1?'关键人手机号':(cleaingTaskform.type == 2?'首位手机号':'手机号')}}</span>
            </el-form-item>
            <div :class="['txt',!taskType?'plTxt':'']">
                    <p v-if="taskType">总计清洗手机号:<span class="colorC">{{cleaningMobileAndneedConsumeNum}}条</span>，需要消耗<span class="colorC">{{cleaningMobileAndneedConsumeNum}}条</span>权益。</p>
                    <p v-else>需要消耗<span class="colorC">{{cleaningMobileAndneedConsumeNum}}条</span>权益。</p>
                    <p>当前剩余检测权益：<span class="colorC">{{cleaningNumberSusplus}}条</span>。</p>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="dialog-cancel" size="small" w88 @click="createCleaningTaskDialog = false">取消</el-button>
          <el-button type="primary" size="small" w88 @click="creatTask('cleaingTaskform')"  :loading="loadingBtn">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {checkTaskName,defaultCleaningTotal,cleaningSusplus,creatCleaningTask} from '@/views/clue/api/cleaningApi'
import { parseTime } from "@/base/global";
export default {
    data(){
        
        var validName = (rule, value, callback) => {
            if (!this.cleaingTaskform.name) {
                // callback(new Error('名称不能为空'))
                this.$message.error('任务名称不能为空')
                this.repeatNameFlag = true
                this.taskMsg = '任务名称不能为空'
            } else {
                if (this.cleaingTaskform.name) {
                    
                     checkTaskName({name:this.cleaingTaskform.name}).then(res =>{
                            if(res.code == 200){
                                this.repeatNameFlag = false
                                callback()
                            }
                    }).catch(err=>{
                        this.repeatNameFlag = true
                        this.taskMsg = '任务名称重复'
                    })
                } else {
                    callback()
                }
            }
        }
        return{
            loadingBtn:false,
            createCleaningTaskDialog:false,
            cleaingTaskform:{
                name:"",
                before:'',//前多少企业
                type:1 //选择范围：1-关键人 2-top1,3-所有
            },
            taskType:true,//true 勾选联系方式，false 未选联系方式(批量)
            cleaningMobileNum:0,//清洗手机号条数
            needConsumeNum:0,//需要消耗权益条数
            cleaningMobileAndneedConsumeNum:'',//清洗手机号条数&需要消耗权益条数
            defaultMaxNum:0,//默认最大的条数
            cleaningNumberSusplus:'',//清洗号码剩余权益条数
            taskInfoVOS:[],//勾选的联系人
            repeatNameFlag:false,//任务名称是否重复
            taskMsg:'',//提示内容
            rules:{
                name:[
                    {required: true,validator: validName, trigger: 'blur'}
                ],
            }
        }
    },
    mounted(){
       
    },
    methods:{
        iniFun(val,arr){

            this.createCleaningTaskDialog = true
            this.taskType = val
            this.cleaningMobileNum = val?arr.length:''
            this.needConsumeNum = val ?arr.length:''
            this.cleaningMobileAndneedConsumeNum = val?arr.length:''

            this.handleGxParams(arr)
            
            this.cleaingTaskform.name = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
            this.cleaingTaskform.before = ''
            this.cleaingTaskform.type = 1
           
            if(!val){
                 this.getDefaultCleaningTotal()
            }
            this.getcleaningSusplus()
        },
        // 处理勾选的联系方式参数
        handleGxParams(arr){
            let gxarr = []
            arr.forEach(v => {
                gxarr.push({
                    sid:v.sid,
                    cid:v.cid,
                    companyName:v.companyName,
                    contactInfo:v.contactInfo || v.content,
                    contactName:v.contactName,
                    estiblishTime:v.estiblishTime,
                    hid:v.hid,
                    keyContact:v.isKeyContact,
                    legalPerson:v.legalPersonName,
                    type:v.type,
                    source: JSON.stringify(v.sources)
                })
            });
           this.taskInfoVOS = gxarr
        },
        // 校验任务名
        checkTaskNameBlur(){
               checkTaskName({name:this.cleaingTaskform.name}).then(res =>{
                    if(res.code == 200){
                        this.repeatNameFlag = false
                    }
               }).catch(err=>{
                   this.repeatNameFlag = true
               })
        },
        async getDefaultCleaningTotal(){
            try{
                const res = await defaultCleaningTotal({type:this.cleaingTaskform.type})
                if(res.code == 200){
                    this.cleaingTaskform.before = res.data
                    this.cleaningMobileAndneedConsumeNum = this.cleaingTaskform.before
                    this.defaultMaxNum = res.data
                    
                }
            }catch(err){
                
            }
            
        },
        async getcleaningSusplus(){
             const res = await cleaningSusplus()
            if(res.code == 200){
                this.cleaningNumberSusplus = res.data
            }
        },
        choiceRange(){
            this.getDefaultCleaningTotal()
        },
        // 选择清洗企业条数
        inputCompanyNum(val){
           const regex = /^[1-9]\d*$/; // 验证输入值是否为数字
           if(!regex.test(val)){
              this.cleaingTaskform.before = ''
              this.cleaningMobileAndneedConsumeNum = this.cleaingTaskform.before
            }else if(val>this.defaultMaxNum){
                    this.cleaingTaskform.before = this.defaultMaxNum
                    this.cleaningMobileAndneedConsumeNum = this.cleaingTaskform.before
               }else{
                   this.cleaningMobileAndneedConsumeNum = this.cleaingTaskform.before
               }
        //    if(!regex.test(val)){
        //        this.cleaingTaskform.before = ''
        //    }else if(this.defaultMaxNum>500){
        //         this.cleaingTaskform.before = val>500?500:val
        //    }else{
        //        this.cleaingTaskform.before = val>this.defaultMaxNum?this.defaultMaxNum:val
        //    }
        //    this.cleaningMobileAndneedConsumeNum = this.cleaingTaskform.before
        },
       async creatTask(formName){
           if(this.cleaningMobileAndneedConsumeNum>this.cleaningNumberSusplus){
               this.$message.error('剩余权益不足')
               return false
           }
           if(this.cleaingTaskform.before<1 && !this.taskType){
               this.$message.error('请输入清洗条数')
               return false
           }

           if(this.repeatNameFlag){
               this.$message.error(this.taskMsg)
               return false
           }
           this.creatTaskSubmit()
        //    this.$refs[formName].validate((valid) => {
        //         if (valid) {
        //                this.creatTaskSubmit()
        //         } else {
        //             console.log('error submit!!');
        //             return false;
        //         }
        //     });
        
        },
      async creatTaskSubmit(){
            let paramsCheck = {
               taskInfoVOS:this.taskInfoVOS
           }
           let paramsBatch = {
               type:this.cleaingTaskform.type,
               before:parseInt(this.cleaingTaskform.before),
           }
           let params = {
               name:this.cleaingTaskform.name,
               selectType:this.taskType?1:2,
           }
            try{
                this.loadingBtn = true
                const res = this.taskType? await creatCleaningTask({...params,...paramsCheck}) : await creatCleaningTask({...params,...paramsBatch})
                if(res.code == 200){
                    this.$message.success('创建成功')
                    this.$parent.changeUnlockList()
                    this.handleClose()
                }
                this.loadingBtn = false
            }catch(err){
                    this.createCleaningTaskDialog = false
                    this.loadingBtn = false
            }
        },
         handleClose(done) {
          this.createCleaningTaskDialog = false
          this.$refs.cleaingTaskform.resetFields()
       }
    }
}
</script>
<style scoped lang="scss">
  ::v-deep{
      .el-dialog__body{
          padding-top: 16px;
      }
      .el-dialog__footer{
          padding: 12px 0;
      }
      .dialog-cleaning-task{
            .task-name{
                .el-form-item__content{
                    width: 226px;
                }
                .el-form-item__label:before{
                    display: none;
                }
            
            }
            .choice-before{
                .el-form-item__content{
                .el-input{
                    width: 76px;
                    margin-right: 8px;
                    margin-left: 8px;
                }
                background: #F2F3F5;
                border-radius: 4px;
                padding: 10px 16px 10px 16px;
                box-sizing: border-box;
                margin-left: 65px !important;
             }
           }
           .choice-range{
               .el-form-item__label,.el-form-item__content{
                   line-height: 20px;
               }
               border-top: 1px solid #F1F1F2;
               padding-top: 16px;
               margin-bottom: 8px;
           }
            .el-radio-group{
                .el-radio{
                        margin-right: 32px;
                        &:last-child{
                            margin-right: 0;
                        }
                }
            }
            .txt{
                padding: 16px;
                box-sizing: border-box;
                background: #F2F3F5;
                border-radius: 4px;
                p{
                    font-weight: 400;
                    color: #666666;
                    line-height: 22px;
                    font-size: 14px;
                }
                &.plTxt{
                    background: none;
                    border-top: 1px solid #F1F1F2;
                }
            }
            .colorC{
                    color: #30BF78;
                }
            .el-dialog__title{
                font-weight: bold;
                color: #333333;
            }
            .tip{
                    padding: 8px;
                    box-sizing: border-box;
                    background: rgba(80,136,255,0.1);
                    border-radius: 4px;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 20px;
                    position: relative;
                    margin-bottom: 16px;
                    color: #5C6075;
                    .el-icon-warning{
                        font-size: 16px;
                        color: #5088FF;
                        vertical-align: text-bottom;
                        margin-right: 8px;
                    }
            }
      }
  }
</style>